import React, { FC, useEffect, useState } from 'react';
import { post, del } from '../../utils/api';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faLock, faUnlock, faRotate as faLoading, faCircleExclamation as faError } from '@fortawesome/free-solid-svg-icons';
import { useAppDispatch, useAppSelector } from '../../hooks/store';
import { requestsAdd, requestsDel } from '../../store/requestsSlice';
import { Request } from '../../types';
import { useTranslation } from 'react-i18next';

export interface SlotLockProps {
	slot_id?: number;
    request_id?: number;
};

const SlotLock: FC<SlotLockProps> = ({ slot_id, request_id }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const to_id = useAppSelector(store => store.auth.user?.id);
	const [ isLoading, setIsLoading ] = useState(false);
    const [ error, setError ] = useState(false);
    // Должен быть указан slot_id, если слот доступен,
    // или request_id, если слот уже отмечен как недоступный
    useEffect(() => {
        if(!slot_id && !request_id) setError(true);
        if(!request_id && !to_id) setError(true);
    }, [ slot_id, request_id, to_id ]);

	const onClick = async (e: React.MouseEvent) => {
        e.stopPropagation();
		setIsLoading(true);
        let result;

        if(request_id) result = await del('/requests/' + request_id);
        else result = await post('/requests', { to_id, slot_id });

		if(result.error) {
			console.error(result.error.text.ru);
            setError(true);
		} else {
            if(request_id) dispatch(requestsDel(request_id));
            else dispatch(requestsAdd(result.data?.request as Request));
        }

        setIsLoading(false);
	};

    if(error) return <span className='Tooltip Icon error'>
        <Icon icon={faError}/>
        <span className='TooltipText'>{t('common.error')}</span>
    </span>;

    if(isLoading) return <span className='Tooltip Icon'>
        <Icon icon={faLoading} className='fa-spin'/>
        <span className='TooltipText'>{t('common.loading')}</span>
    </span>;
	
    return <span className='Tooltip Icon'>
        <Icon icon={request_id ? faLock : faUnlock} onClick={onClick}/>
        <span className='TooltipText'>{request_id ? t('profile.slot.unlock') : t('profile.slot.lock')}</span>
    </span>;
};

export default SlotLock;
